import { createSlice } from "@reduxjs/toolkit";
import { fetchYearData } from "../thunks/yearThunk";

const headerSlice = createSlice({
  name: 'header',
  initialState: {
    headerName: "Education Dashboard",
    removeBeforeAfterClass: 'main-card-home',
    isViewDataByShow: true,
    regionName: "States",
    showDistricts: false,
    currentIndex: 0,
    show: false,
    activeTab: "table",
    selectYear: "2021-22",
    reserveUpdatedFilter: {},
    arrGroupedGraph3013Data: {
      graphData: [],
      pieGraphData: [],
      pieGraphDatas:[]
    },
 
    selectedField3013graph: {
      field: "totSchLandAvail",
      label: "Land Available"
    },
    selectedField3016graph: {
      field: "value",
      label: "Electricity Available"
    },
    selectedField3019graph: {
      field: "value",
      label: "Seprate Room for Headmaster"
    },
    selectedField3022graph: {
      field: "value",
      label: "School having Land"
    },
    selectedField3025graph: {
      field: "value",
      label: "School having Solar"
    },
    selectedField3028graph: {
      field: "value",
      label: "School having Playground"
    },
    selectedField3031graph: {
      field: "value",
      label: "School having Library"
    },
    selectedField3034graph: {
      field: "value",
      label: "School having Librarian"
    },
    selectedField3037graph: {
      field: "value",
      label: "School having Librarian"
    },
    selectedField3040graph: {
      field: "value",
      label: "School having Kitchen Garden"
    },
    selectedField3043graph: {
      field: "value",
      label: "School having Furniture"
    },
    selectedField3046graph: {
      field: "value",
      label: "School having Boys Toilet"
    },
    selectedField3052graph: {
      field: "value",
      label: "School having Girls Toilet"
    },
    selectedField3058graph: {
      field: "value",
      label: "School having Toilet"
    },
    selectedField3064graph: {
      field: "value",
      label: "School having Boys Urinal"
    },
    selectedField3067graph: {
      field: "value",
      label: "School having Girls Urinal"
    },
    selectedField3070graph: {
      field: "value",
      label: "School having Urinal"
    },
    selectedField3082graph: {
      field: "value",
      label: "School having Rain Water harvesting Facility"
    },
    selectedField3088graph: {
      field: "value",
      label: "School having Hand Wash Facility"
    },
    selectedField3091graph: {
      field: "value",
      label: "School having Incinerator  Facility"
    },
    selectedField3097graph: {
      field: "value",
      label: "School having Ramps Facility"
    },
    selectedField3098graph: {
      field: "value",
      label: "School having Handrail Facility"
    },
    selectedField3100graph: {
      field: "value",
      label: "School having Medical Checkup Facility"
    },
    selectedField3106graph: {
      field: "value",
      label: "School having Computer Available"
    },
    pieGraph3013mngSchSelected:"School Management",
    selectYearId:9,
    onDrilldownMap:false

  },
  reducers: {
    handleShowDistrict(state, action) {
      state.showDistricts = action.payload
    },
    updateHeaderName(state, action) {
      state.headerName = action.payload;
    },
    removeBeforeAfterClass(state, action) {
      state.removeBeforeAfterClass = action.payload
    },
    handleViewDataByShow(state, action) {
      state.isViewDataByShow = action.payload
    },
    handleRegionName(state, action) {
      state.regionName = action.payload
    },
    handleCurrentIndex(state, action) {
      state.currentIndex = action.payload
    },
    handleShowFilter(state, action) {
      state.show = action.payload
    },
    handleActiveTabs(state, action) {
      state.activeTab = action.payload
    },
    handleSelectYear(state, action) {
      state.selectYear = action.payload
    },


    setReserveUpdatedFilter(state, action) {
      state.reserveUpdatedFilter = {
        regionType: action.payload.regionType,
        regionCode: action.payload.regionCode,
        dType: action.payload.dType,
        dCode: action.payload.dCode,
        dashboardRegionType: action.payload.dashboardRegionType,
        dashboardRegionCode: action.payload.dashboardRegionCode,
        valueType: action.payload.valueType,
        locationCode: action.payload.locationCode,
        managementCode: action.payload.managementCode,
        categoryCode: action.payload.categoryCode,
        schoolTypeCode: action.payload.schoolTypeCode,
        yearId: action.payload.yearId
      }
    },
    setArrGroupedGraph3013Data(state, action) {
      state.arrGroupedGraph3013Data = {
        graphData: action.payload.graphData || [],
        pieGraphData: action.payload.pieGraphData || [],
        pieGraphDatas:action.payload.pieGraphDatas || []
      };
    },
    
    setpieGraph3013mngSchSelected(state, action) {
      state.pieGraph3013mngSchSelected = action.payload
    },
    setSelectedField3013graph(state, action) {
      state.selectedField3013graph = action.payload
    },
    setSelectedField3016graph(state, action) {
      state.selectedField3016graph = action.payload
    },
    setSelectYearId(state, action) {
      state.selectYearId = action.payload
    },
    setonDrilldownMap(state, action){
      state.onDrilldownMap = action.payload
    }
  },

  extraReducers: (builder) => {
 
    builder
    .addCase(fetchYearData.pending, (state) => {
    state.isLoading = true;
    })
    .addCase(fetchYearData.fulfilled, (state, action) => {
    state.isLoading = false;
    state.selectYearId = action.payload.data[0].yearId
    state.selectYear =action.payload.data[0].yearDesc
    const obj = {
      yearId:action.payload.data[0].yearId,
      yearDesc:action.payload.data[0].yearDesc
    }
    localStorage.setItem("acData",JSON.stringify(obj))
    localStorage.setItem("acDataForReset",JSON.stringify(obj))
    })
    .addCase(fetchYearData.rejected, (state, action) => {
    state.isLoading = false;
    state.isError = true;
    })
    
    },
})

export const { updateHeaderName, removeBeforeAfterClass, handleViewDataByShow, handleRegionName, handleShowDistrict, handleCurrentIndex, handleDisableBtn, handleShowFilter, handleActiveTabs, handleSelectYear, setReserveUpdatedFilter, setArrGroupedGraph3013Data, setSelectedField3013graph,setpieGraph3013mngSchSelected,setSelectYearId, setonDrilldownMap } = headerSlice.actions
export default headerSlice.reducer